import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { CountrySpecificData } from '@percent/admin-dashboard/app/validations/nonprofitDetail/dialogs/registryModal/RegistryModal.types'
import { dgrStatuses } from '@percent/admin-dashboard/api/types'

export const DGR_STATUS = {
  NO_STATUS: 'no-status',
  AUS_DGR1: 'aus-dgr1',
  AUS_DGR2: 'aus-dgr2',
  AUS_DGR1_AND_4: 'aus-dgr1, aus-dgr4'
} as const

export type DgrStatus = typeof DGR_STATUS[keyof typeof DGR_STATUS]

export const useGetDgrHelpers = () => {
  const { t } = useTranslation()

  const mapCountrySpecificDataToDgr = (countrySpecificData?: CountrySpecificData) => {
    if (
      countrySpecificData?.dgrStatusList?.includes(dgrStatuses.AUS_DGR1) &&
      countrySpecificData?.dgrStatusList?.includes(dgrStatuses.AUS_DGR4)
    ) {
      return t('typography.DGR1&4')
    }

    if (countrySpecificData?.dgrStatusList?.includes(dgrStatuses.AUS_DGR1)) {
      return t('typography.DGR1')
    }

    if (countrySpecificData?.dgrStatusList?.includes(dgrStatuses.AUS_DGR2)) {
      return t('typography.DGR2')
    }

    return undefined
  }

  const dgrOptions = useMemo(() => {
    return [
      { label: t('typography.noStatus'), value: DGR_STATUS.NO_STATUS },
      { label: t('typography.DGR1'), value: DGR_STATUS.AUS_DGR1 },
      { label: t('typography.DGR2'), value: DGR_STATUS.AUS_DGR2 },
      { label: t('typography.DGR1&4'), value: DGR_STATUS.AUS_DGR1_AND_4 }
    ]
  }, [t])

  return { dgrOptions, mapCountrySpecificDataToDgr }
}
